import { useNotifications } from "@relode/core";
import * as React from "react";

import { DashboardActions } from "./dashboardActions";
import { DashboardState } from "./dashboardState";

export const useDashboardErrorHandlers = (
    state: DashboardState,
    actions: DashboardActions
) => {
    const { actions: notifications } = useNotifications();
    const {
        ui: { error },
    } = state;

    React.useEffect(() => {
        if (!error) return; // we don't close from here.  might be odd

        const message =
            error?.friendlyMessages ?? "we've encountered a problem";

        if (error?.summary) {
            notifications.showModal("error", "we're so sorry", message);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error]);
};
